import { createSlice } from "@reduxjs/toolkit";

export const member = createSlice({
  name: "member",
  initialState: {
    dataMember: []
  },
  reducers: {
    storeDataMember: (state, action) => {
      state.dataMember = action.payload;
    },
  },
});

export const {
  storeDataMember
} = member.actions;

export default member.reducer;